import React, { PureComponent } from 'react'
import DesignerBody from '../components/DesignerBody.js'
import CushionDesignerSteps from '../components/CushionDesignerSteps.js'
import { Redirect, Route, Switch } from 'react-router-dom'
import CushionFillingSelector from '../components/CushionFillingSelector.js'
import CushionFastenerSelector from '../components/CushionFastenerSelector.js'
import CushionStyleSelector from '../components/CushionStyleSelector.js'
import CushionFabricSelector from '../components/CushionFabricSelector/CushionFabricSelector.js'
import CushionDimensionsSelector from '../components/CushionDimensionsSelector.js'
import CushionShapeSelector from '../components/CushionShapeSelector.js'
import CushionTypeSelector from '../components/CushionTypeSelector.js'
import { DESIGNER_STEPS, DESIGNER_STEPS_URLS } from '../utils/config.js'
import '../../css/App.scss'

class DefaultRouter extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      extraSpace: '',
    }
  }

  render() {
    const { extraSpace } = this.state
    return (
      <div className={extraSpace}>
        <DesignerBody urls={DESIGNER_STEPS_URLS}>
          <CushionDesignerSteps steps={DESIGNER_STEPS} urls={DESIGNER_STEPS_URLS} />
          <Switch>
            <Route
              path={'/cd/:category/:type/:shape/:dimensions/:fabric/:style/:fasteners/:filling'}
            >
              <CushionFillingSelector />
            </Route>
            <Route path={'/cd/:category/:type/:shape/:dimensions/:fabric/:style/:fasteners'}>
              <CushionFastenerSelector />
            </Route>
            <Route path={'/cd/:category/:type/:shape/:dimensions/:fabric/:style'}>
              <CushionStyleSelector />
            </Route>
            <Route path={'/cd/:category/:type/:shape/:dimensions/:fabric'}>
              <CushionFabricSelector />
              <p className={'cushion-designer-footer-text'}></p>
            </Route>
            <Route path={'/cd/:category/:type/:shape/:dimensions'}>
              <CushionDimensionsSelector />
            </Route>
            <Route path={'/cd/:category/:type/:shape'}>
              <CushionShapeSelector />
            </Route>
            <Route path={'/cd/:category/:type'}>
              <div className={'cushion-designer-layout type-selector'}>
                <p className={'cushion-designer-footer-text'}>
                  Welcome to the Cushion Designer, a one-of-a-kind custom cushion builder engineered
                  to put ease and enjoyment at the forefront of design. Follow the step-by-step
                  prompts on screen to create your custom cushion.
                </p>
                <CushionTypeSelector />
              </div>
            </Route>
            <Route path={'/cd/:category'}>
              <Redirect to={'/cd/category/type'} />
            </Route>
            <Route exact path={'/cd'}>
              <Redirect to={'/cd/category/type'} />
            </Route>
            <Route exact path={'/'}>
              <Redirect to={'/cd/category/type'} />
            </Route>
          </Switch>
        </DesignerBody>
      </div>
    )
  }
}

export default DefaultRouter
